/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-13 14:51:10
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-13 15:33:24
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/SimpleProduct/SalesChannelAvaliability/index.tsx
 */
import React from 'react';

import { useSelector, useDispatch } from 'react-redux';

import {
  onLinkedSalesChannelsProductsChange,
  getLinkedSalesChannels,
  onLinkedSalesChannelsProductsDelete,
} from '../Slice';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import AvailableTable from '@/src/pages/ProductEditor/Components/SalesChannelAvailablity';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Available = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const data = useSelector(getLinkedSalesChannels());
  const _d = useDispatch();
  const handleOnProductsChange = (p) => {
    _d(onLinkedSalesChannelsProductsChange(p));
  };
  const handleOnProductDelete = (data) => {
    _d(onLinkedSalesChannelsProductsDelete(data));
  };
  return (
    <SectionWrapper
      title={getI18n('allProducts.addproductset.salesChannelAvailability')}>
      <AvailableTable
        data={data}
        onProductsAdd={handleOnProductsChange}
        onProductDelete={handleOnProductDelete}
        disabled={props.disabled}
      />
    </SectionWrapper>
  );
};
export default Available;
